(function() {
  var PPHybrid;

  PPHybrid = App.loadClass("grower::classes/placement/PlantingPlanHybrid");

  exports.Selections = function(handler) {
    var self;
    self = this;
    this.setPlan = function(fieldID, hybrids) {
      var hyb, hybrid, hybridOrdering, i, len, plantingPlans;
      plantingPlans = self.plantingPlans();
      hybridOrdering = self.hybridOrdering();
      plantingPlans({
        fieldID: fieldID
      }).remove();
      for (i = 0, len = hybrids.length; i < len; i++) {
        hybrid = hybrids[i];
        if (!(hybrid instanceof PPHybrid)) {
          debugLog('Not a valid PlantingPlanHybrid object');
          debugLog(hybrid);
          continue;
        }
        plantingPlans.insert(hybrid.get());
        hyb = hybrid.getHybrid();
        if (hybridOrdering(hyb).count() === 0) {
          hybridOrdering.insert(hyb);
        }
      }
      self.plantingPlans(plantingPlans);
      return self.hybridOrdering(hybridOrdering);
    };
    this.plantingPlans = ko.observable(TAFFY());
    this.hybridOrdering = ko.observable(TAFFY());
    this.hybrids = ko.computed(function() {
      var h, htmlString, i, len, results, tbody;
      results = [];
      self.plantingPlans();
      self.hybridOrdering()().each(function(hybrid) {
        var conditions, duplicate, i, len, result;
        hybrid = $.extend({}, hybrid);
        conditions = {
          hybridID: hybrid.id,
          treatmentID: hybrid.treatmentID
        };
        hybrid.units = self.plantingPlans()(conditions).sum('units');

        /*
            Prevent duplicates from appearing the sidebar
            https://www.pivotaltracker.com/story/show/150457617
         */
        duplicate = false;
        for (i = 0, len = results.length; i < len; i++) {
          result = results[i];
          if (!(result.id === hybrid.id && result.treatmentID === hybrid.treatmentID)) {
            continue;
          }
          duplicate = true;
          break;
        }
        if (!duplicate && hybrid.units > 0) {
          return results.push(hybrid);
        }
      });
      tbody = $('#tbody-units');
      tbody.children().remove();
      for (i = 0, len = results.length; i < len; i++) {
        h = results[i];
        htmlString = "<tr> <td>" + h.displayName + "</td> <td class='text-right'>" + h.units + "</td> </tr>";
        tbody.append(htmlString);
      }
      return results;
    });
    this.totalUnits = ko.computed(function() {
      return self.plantingPlans()().sum('units');
    });
    this.show_hr = ko.observable(handler.parent.has_multiple_steps);
    return this;
  };

}).call(this);
